import { createFileRoute } from '@tanstack/react-router';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { stacktraceNS, useTranslation } from '@/lib/i18n';
import { CustomerAddPage } from './-components/CustomerAddPage';

/**
 * 顧客 (Customer) 新規追加画面 (route 登録)。
 *
 * 取引先紐付けを前提とした 3 ペイン (左ナビ / 中央フォーム / 右プログレス)
 * の追加導線。values/add と同パターンで Zustand store + URL hash により
 * Step1 (基本情報) / Step2 (契約・メモ) を切り替える。本体実装は
 * `-components/CustomerAddPage.tsx` に分離する。
 */
export const Route = createFileRoute('/_stacktrace/customers/add/')({
  component: CustomerAddRouteComponent
});
function CustomerAddRouteComponent() {
  const {
    t
  } = useTranslation(stacktraceNS, {
    keyPrefix: 'customers.add'
  });
  useDocumentTitle(t('pageTitle'));
  return <CustomerAddPage />;
}